import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={21.396}
    height={26.584}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 37422 46497"
    {...props}
  >
    <defs>
      <style>
        {".str1{stroke:#2b2a29;stroke-width:1322.13}.fil1{fill:#1c1b17}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974319837088">
        <path
          d="M13784 32949h22793c-41-1777-2348-7058-3251-9528-410-1123-687-2559-1930-2559H18273c-1475 0-2392 3609-3308 6017-1242 3267-2990 6070-1181 6070z"
          style={{
            fill: "none",
            stroke: "#2b2a29",
            strokeWidth: 1652.66,
          }}
          className="stroke1"
        />
        <path
          d="M661 13415c2887 64 4781 1571 6561 2762 0-4436-576-8006 1300-11133 3250-5415 12385-6449 16211 529 1660 3026 1138 7496 1138 11986 1397 373 1687 1037 1726 2762h-4835c-1812 0-635-2316 1036-2762 0-5372 887-10779-3160-13416-4574-2979-9085-652-10668 2694-2228 4710 1154 14570-2061 19697-1302 2076-3827 3803-7248 3803V13415zM13439 38475c1606 340 1231 7 2771-677 1405-623 1910-244 2063-2086-1606-340-1233-7-2772 676-1404 624-1909 244-2062 2087zM31051 43310c1097-1313-1161-4225-2073-4835-1436 807-897 1175-79 2483 807 1289 688 1960 2152 2352zM18273 43310c1543-1033 3852-4835 2072-4835-1121 0-1279 1287-1885 2272-969 1578-1152 1122-187 2563zM31051 37094c1549 360 4108 2610 4444 985 314-1523-3080-2367-4444-2367v1382zM25163 45612c820-1667 918-6114-624-5224-969 560-464 1754-495 2910-51 1851-438 1547 1119 2314z"
          className="fil1"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
